import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import { ProgressBarComponent } from "@syncfusion/ej2-react-progressbar";

import { getMailBoxUsage } from '../../services/folder';
import ZipIcon from '../../assets/icons/zip.svg?react';
import './mailbox-usage.scss';
import { formatSize } from '../../utils/utils';

export const MailboxUsage = ({getStorageUsage, credentials, collapsed}) => {
  const { t } = useTranslation();
  const progressBarRef = useRef(null);
  const [mailboxUsage, setMailboxUsage] = React.useState({});
  const [isOverQuota, setIsOverQuota] = React.useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const newMailboxUsage = await getStorageUsage(credentials);
      setMailboxUsage(newMailboxUsage || {});
    };
    fetchData();
  }, []);

  useEffect(() => {
    const overQuota = mailboxUsage.percentage >= 100;
    if (progressBarRef.current && overQuota) {
      setTimeout(() => {
        progressBarRef.current.refresh();
      }, 100);
    }
    setIsOverQuota(overQuota);
  }, [mailboxUsage.percentage]);

  // Sin cuota conocida (maxKB null/0) solo se muestra el espacio usado, sin total ni % (barra azul completa)
  const hasQuota = !!mailboxUsage.maxKB;
  const usedKB = hasQuota
    ? (mailboxUsage.maxKB * mailboxUsage.percentage) / 100
    : mailboxUsage.usedKB;

  return (
    <>
      {!collapsed && (
        <div className="mailbox-usage-container">
            <div className="divider" />
            <div className="d-flex align-items-center">
              <ZipIcon className="icon-zip" />
              <div>
                <span className={`inter-semibold-14 ml-2 ${isOverQuota ? 'text-color-persian-red-200' : hasQuota ? 'text-color-grey-800' : 'text-color-tertiary-byzantine-blue-200'}`}>
                  {usedKB != null && formatSize(usedKB)}
                </span>
                <span className="inter-regular-12 text-color-grey-500 ml-1">
                  {hasQuota ? t('sideBar.used_of', { total: formatSize(mailboxUsage.maxKB) }) : usedKB != null && t('sideBar.used').toLowerCase()}
                </span>
              </div>
            </div>
            <ProgressBarComponent
              ref={(progressBar) => {
                progressBarRef.current = progressBar;
              }}
              id="lineardeterminate"
              type="Linear"
              width="230px"
              height="4px"
              progressColor={isOverQuota ? 'var(--persian-red-200)' : 'var(--tertiary-byzantine-blue-200)'}
              trackThickness={4}
              progressThickness={4}
              trackColor="var(--grey-300)"
              cornerRadius="Round"
              radius="8px"
              value={hasQuota ? mailboxUsage.percentage && Math.min(mailboxUsage.percentage, 100) : (usedKB != null ? 100 : 0)}
              animation={{
                enable: true,
                duration: 2000,
                delay: 0
              }}
            />
            <div className="d-flex align-items-center mt-2 ml-3">
              <div className="used_circle circle" />
              <span className="inter-regular-12 text-color-grey-500 ml-1">{
                t('sideBar.used')}
              </span>
              {hasQuota && (
                <>
                  <div className="free_circle circle ml-3" />
                  <span className="inter-regular-12 text-color-grey-500 ml-1">{
                    t('sideBar.free')}
                  </span>
                </>
              )}
            </div>
        </div>
      )}
      {
        collapsed && (
          <div className="mailbox-usage-collapsed">
            <ProgressBarComponent
              ref={(progressBar) => {
                progressBarRef.current = progressBar;
              }}
              id="lineardeterminate"
              type="Linear"
              width="100%"
              height="4px"
              progressColor={isOverQuota ? 'var(--persian-red-200)' : 'var(--tertiary-byzantine-blue-200)'}
              trackThickness={4}
              progressThickness={4}
              trackColor="var(--grey-300)"
              cornerRadius="Round"
              radius="8px"
              value={hasQuota ? mailboxUsage.percentage && Math.min(mailboxUsage.percentage, 100) : (usedKB != null ? 100 : 0)}
              animation={{
                enable: true,
                duration: 2000,
                delay: 0
              }}
            />
          </div>
        )
      }
    </> 
  );
};

MailboxUsage.propTypes = {};

const mapStateToProps = (state) => ({
  credentials: state.application.user.credentials,
});

const mapDispatchToProps = (dispatch) => ({
  getStorageUsage: (credentials) =>
      getMailBoxUsage(dispatch, credentials),
});

export default connect(mapStateToProps, mapDispatchToProps)(MailboxUsage);
